import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/home/logo-1.png';
import _imports_1 from '@/assets/imgs/home/close.png';

const _withScopeId = n => (_pushScopeId("data-v-0ee1a053"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "nav-destop"
};
const _hoisted_2 = {
  class: "mainnavlist"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "txt light-txt"
}, "|", -1));

const _hoisted_4 = {
  key: 1,
  id: "nav-mobile-wrapper"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  key: 0,
  class: "mobile-menu-list"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cutting-line"
}, null, -1));

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cutting-line"
}, null, -1));

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cutting-line"
}, null, -1));

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cutting-line"
}, null, -1));

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cutting-line"
}, null, -1));

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cutting-line"
}, null, -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return !_ctx.isMobile ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
    class: "bpk_logo",
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    (...args) => _ctx.handleHomeRouter && _ctx.handleHomeRouter(...args)),
    src: _imports_0
  }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    onClick: _cache[1] || (_cache[1] = $event => _ctx.routerPush('/AboutCoach')),
    class: "txt side-margin tabbar"
  }, _toDisplayString(_ctx.$t("m.aboutCoach")), 1), _createElementVNode("div", {
    onClick: _cache[2] || (_cache[2] = $event => _ctx.routerPush('/UserStory')),
    class: "txt side-margin tabbar"
  }, _toDisplayString(_ctx.$t("m.userStory")), 1), _createElementVNode("div", {
    onClick: _cache[3] || (_cache[3] = $event => _ctx.routerPush('/EnterpriseBuy')),
    class: "txt side-margin tabbar"
  }, _toDisplayString(_ctx.$t("m.enterpriseBuy")), 1), _createElementVNode("div", {
    onClick: _cache[4] || (_cache[4] = $event => _ctx.routerPush('/AboutUs')),
    class: "txt side-margin tabbar"
  }, _toDisplayString(_ctx.$t("m.aboutUs")), 1), _createElementVNode("div", {
    onClick: _cache[5] || (_cache[5] = $event => _ctx.routerPush('/JoinUs')),
    class: "txt side-margin tabbar"
  }, _toDisplayString(_ctx.$t("m.joinUs")), 1), _createElementVNode("div", {
    onClick: _cache[6] || (_cache[6] = $event => _ctx.changeLanguage('zh-CN')),
    class: "txt",
    style: _normalizeStyle({
      color: !_ctx.isZhCN ? 'rgba(0,0,0,0.45)' : 'rgba(0,0,0,0.85)'
    })
  }, " 中 ", 4), _hoisted_3, _createElementVNode("div", {
    onClick: _cache[7] || (_cache[7] = $event => _ctx.changeLanguage('en-US')),
    class: "txt",
    style: _normalizeStyle({
      color: _ctx.isZhCN ? 'rgba(0,0,0,0.45)' : 'rgba(0,0,0,0.85)'
    })
  }, " EN ", 4)])])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", {
    class: _normalizeClass({
      'nav-mobile': true,
      'nav-mobile-dark': !_ctx.showLight,
      'nav-mobile-wo-mask': _ctx.showMenu
    })
  }, [_createElementVNode("img", {
    class: "bpk_logo",
    src: require(_ctx.showLight ? '@/assets/imgs/home/logo-light.png' : '@/assets/imgs/home/logo.png'),
    onClick: _cache[8] || (_cache[8] = //@ts-ignore
    (...args) => _ctx.handleHomeRouter && _ctx.handleHomeRouter(...args))
  }, null, 8, _hoisted_5), !_ctx.showMenu ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    class: "menu-logo",
    src: require(_ctx.showLight ? '@/assets/imgs/home/menu-light.png' : '@/assets/imgs/home/menu.png'),
    onClick: _cache[9] || (_cache[9] = //@ts-ignore
    (...args) => _ctx.openMenu && _ctx.openMenu(...args))
  }, null, 8, _hoisted_6)) : (_openBlock(), _createElementBlock("img", {
    key: 1,
    class: "menu-logo",
    src: _imports_1,
    onClick: _cache[10] || (_cache[10] = //@ts-ignore
    (...args) => _ctx.closeMenu && _ctx.closeMenu(...args))
  }))], 2), _ctx.showMenu ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", {
    class: "link-txt",
    onClick: _cache[11] || (_cache[11] = $event => _ctx.routerPush('/AboutCoach')),
    ontouchstart: ""
  }, _toDisplayString(_ctx.$t("m.aboutCoach")), 1), _hoisted_8, _createElementVNode("div", {
    class: "link-txt",
    onClick: _cache[12] || (_cache[12] = $event => _ctx.routerPush('/UserStory')),
    ontouchstart: ""
  }, _toDisplayString(_ctx.$t("m.userStory")), 1), _hoisted_9, _createElementVNode("div", {
    class: "link-txt",
    onClick: _cache[13] || (_cache[13] = $event => _ctx.routerPush('/EnterpriseBuy')),
    ontouchstart: ""
  }, _toDisplayString(_ctx.$t("m.enterpriseBuy")), 1), _hoisted_10, _createElementVNode("div", {
    class: "link-txt",
    onClick: _cache[14] || (_cache[14] = $event => _ctx.routerPush('/AboutUs')),
    ontouchstart: ""
  }, _toDisplayString(_ctx.$t("m.aboutUs")), 1), _hoisted_11, _createElementVNode("div", {
    class: "link-txt",
    onClick: _cache[15] || (_cache[15] = $event => _ctx.routerPush('/JoinUs')),
    ontouchstart: ""
  }, _toDisplayString(_ctx.$t("m.joinUs")), 1), _hoisted_12, _createElementVNode("div", {
    class: "link-txt",
    onClick: _cache[16] || (_cache[16] = $event => _ctx.changeLanguage()),
    ontouchstart: ""
  }, _toDisplayString(_ctx.$t("m.changeLang")), 1), _hoisted_13])) : _createCommentVNode("", true)]));
}